// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_selections.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AccessReviewSelectionsSearchService } from "./accessreview_selections";
import type { AccessReviewSelectionsSearchServiceSearchResponse } from "./accessreview_selections";
import type { AccessReviewSelectionsSearchServiceSearchRequest } from "./accessreview_selections";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AccessReviewSelectionsService } from "./accessreview_selections";
import type { AccessReviewSelectionsServiceAddResponse } from "./accessreview_selections";
import type { AccessReviewSelectionsServiceAddRequest } from "./accessreview_selections";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AccessReviewSelectionsServiceListResponse } from "./accessreview_selections";
import type { AccessReviewSelectionsServiceListRequest } from "./accessreview_selections";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewSelectionsService
 */
export interface IAccessReviewSelectionsServiceClient {
    /**
     * @generated from protobuf rpc: List(c1.api.accessreview.v1.AccessReviewSelectionsServiceListRequest) returns (c1.api.accessreview.v1.AccessReviewSelectionsServiceListResponse);
     */
    list(input: AccessReviewSelectionsServiceListRequest, options?: RpcOptions): UnaryCall<AccessReviewSelectionsServiceListRequest, AccessReviewSelectionsServiceListResponse>;
    /**
     * @generated from protobuf rpc: Add(c1.api.accessreview.v1.AccessReviewSelectionsServiceAddRequest) returns (c1.api.accessreview.v1.AccessReviewSelectionsServiceAddResponse);
     */
    add(input: AccessReviewSelectionsServiceAddRequest, options?: RpcOptions): UnaryCall<AccessReviewSelectionsServiceAddRequest, AccessReviewSelectionsServiceAddResponse>;
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewSelectionsService
 */
export class AccessReviewSelectionsServiceClient implements IAccessReviewSelectionsServiceClient, ServiceInfo {
    typeName = AccessReviewSelectionsService.typeName;
    methods = AccessReviewSelectionsService.methods;
    options = AccessReviewSelectionsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: List(c1.api.accessreview.v1.AccessReviewSelectionsServiceListRequest) returns (c1.api.accessreview.v1.AccessReviewSelectionsServiceListResponse);
     */
    list(input: AccessReviewSelectionsServiceListRequest, options?: RpcOptions): UnaryCall<AccessReviewSelectionsServiceListRequest, AccessReviewSelectionsServiceListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSelectionsServiceListRequest, AccessReviewSelectionsServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Add(c1.api.accessreview.v1.AccessReviewSelectionsServiceAddRequest) returns (c1.api.accessreview.v1.AccessReviewSelectionsServiceAddResponse);
     */
    add(input: AccessReviewSelectionsServiceAddRequest, options?: RpcOptions): UnaryCall<AccessReviewSelectionsServiceAddRequest, AccessReviewSelectionsServiceAddResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSelectionsServiceAddRequest, AccessReviewSelectionsServiceAddResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewSelectionsSearchService
 */
export interface IAccessReviewSelectionsSearchServiceClient {
    /**
     * @generated from protobuf rpc: Search(c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchRequest) returns (c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchResponse);
     */
    search(input: AccessReviewSelectionsSearchServiceSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewSelectionsSearchServiceSearchRequest, AccessReviewSelectionsSearchServiceSearchResponse>;
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewSelectionsSearchService
 */
export class AccessReviewSelectionsSearchServiceClient implements IAccessReviewSelectionsSearchServiceClient, ServiceInfo {
    typeName = AccessReviewSelectionsSearchService.typeName;
    methods = AccessReviewSelectionsSearchService.methods;
    options = AccessReviewSelectionsSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search(c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchRequest) returns (c1.api.accessreview.v1.AccessReviewSelectionsSearchServiceSearchResponse);
     */
    search(input: AccessReviewSelectionsSearchServiceSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewSelectionsSearchServiceSearchRequest, AccessReviewSelectionsSearchServiceSearchResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSelectionsSearchServiceSearchRequest, AccessReviewSelectionsSearchServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
}
